import React, { FC } from 'react'

import { DismissibleCardItem } from '@smarty-nx/contentful'
import { Link as RouterLink } from 'react-router-dom'

import classes from './tile.module.scss'
import { ContentfulProcessor } from '../../contentful-processor/contentful-processor'
import { Icon } from '../../icon/icon'
import { Link } from '../../Link/Link'

interface TileProps extends DismissibleCardItem {
  onRequestClose?: (banner: DismissibleCardItem) => void
}

export const Tile: FC<TileProps> = (banner) => {
  const {
    title,
    markdownDescription = '',
    icon,
    ctaLink,
    showCloseButton,
    onRequestClose,
  } = banner
  return (
    <div className={classes.root}>
      {onRequestClose && showCloseButton && (
        <div className={classes.buttonContainer}>
          <button
            className={classes.closeButton}
            onClick={() => onRequestClose(banner)}
            data-testid="close-modal"
            data-item-category="GI"
            data-item-name="dismiss"
          >
            <Icon name="close" />
          </button>
        </div>
      )}
      <div className={classes.title}>{title}</div>
      <div className={classes.description}>
        <ContentfulProcessor
          content={markdownDescription}
          components={{
            a({ node: _, children, href, ...props }) {
              return (
                <Link
                  props={props}
                  href={href}
                  className={classes.link}
                  component={RouterLink}
                >
                  {children}
                </Link>
              )
            },
          }}
        />
      </div>
      {ctaLink && (
        <ContentfulProcessor
          content={ctaLink}
          components={{
            a({ node: _, children, href, ...props }) {
              return (
                <Link
                  props={props}
                  href={href}
                  className={classes.ctaLink}
                  component={RouterLink}
                >
                  {children}
                </Link>
              )
            },
          }}
        />
      )}
      {icon?.file?.url && (
        <img src={icon?.file?.url} className={classes.image} alt={title} />
      )}
    </div>
  )
}
